import { useLocation } from "react-router-dom";
import { Phone, MessageCircle } from "lucide-react";
import { useSettings } from "@/lib/settings";

export default function FloatingContact() {
  const { settings } = useSettings();
  const loc = useLocation();
  if (loc.pathname.startsWith("/admin")) return null;
  // Hide on car detail on mobile (has its own sticky action bar)
  const isCarDetail = /^\/masini\/[^/]+$/.test(loc.pathname);

  const phone = settings.phone.replace(/\s/g, "");
  const wa = settings.whatsapp.replace(/\s/g, "");

  return (
    <div
      className={`fixed right-4 z-40 flex flex-col gap-3 ${isCarDetail ? "hidden md:flex bottom-5" : "bottom-5 md:bottom-6"}`}
      style={{ bottom: "max(1.25rem, env(safe-area-inset-bottom))" }}
    >
      <a
        href={`https://wa.me/40${wa.replace(/^0/, "")}`}
        target="_blank"
        rel="noopener noreferrer"
        className="h-14 w-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:scale-105 active:scale-95 transition-transform"
        aria-label="WhatsApp"
        data-testid="floating-whatsapp"
      >
        <MessageCircle className="h-6 w-6" />
      </a>
      <a
        href={`tel:${phone}`}
        className="h-14 w-14 rounded-full bg-[#0A0A0A] text-white flex items-center justify-center shadow-lg hover:scale-105 active:scale-95 transition-transform md:hidden"
        aria-label="Sună"
        data-testid="floating-phone"
      >
        <Phone className="h-6 w-6" />
      </a>
    </div>
  );
}
